import { Box, Chip } from "@mui/material";
import { daysOfWeek, SchedulerFilterDialogInput } from "./FilterDialogModal";
import { capitalize } from "lodash";
import { SchedulerProvidersListQuery } from "~/graphql/__generated__/graphql";
import { FilterChip } from "../common/forms/FilterChip";

type Props = {
  allowUseOverflowShifts: boolean,
  values: SchedulerFilterDialogInput,
  setValues: (values: SchedulerFilterDialogInput) => void,
  onClick: () => void,
  providers: SchedulerProvidersListQuery["scheduleProvidersList"],
};

export default function SchedulerFilterChips({
  allowUseOverflowShifts,
  values,
  setValues,
  onClick,
  providers,
}: Props) {
  return <>
    <Box m={0.5}>
      <FilterChip
        label={values.daysOfWeek.map((d: any) => daysOfWeek[d].label).join(', ')}
        emptyLabel="Any day"
        onDelete={() => setValues({ ...values, daysOfWeek: [] })}
        onClick={onClick}
        selected={values.daysOfWeek.length > 0}
      />
    </Box>
    <Box m={0.5}>
      <FilterChip
        label={capitalize(values.timeOfDay)}
        emptyLabel="Any time"
        onDelete={() => setValues({ ...values, timeOfDay: "" })}
        onClick={onClick}
        selected={!!values.timeOfDay}
      />
    </Box>
    <Box m={0.5}>
      <FilterChip
        label={values.provider.map(id => providers.find(p => p.id.toString() === id)).map(p => p ? `${p.firstName} ${p.lastName}` : '').join(', ')}
        emptyLabel="Any provider"
        onDelete={() => setValues({ ...values, provider: [] })}
        onClick={onClick}
        selected={values.provider.length > 0}
      />
    </Box>
    <Box m={0.5}>
      <FilterChip
        label={capitalize(values.providerGender)}
        emptyLabel="Any gender"
        onDelete={() => setValues({ ...values, providerGender: "" })}
        onClick={onClick}
        selected={!!values.providerGender}
      />
    </Box>
    <Box m={0.5}>
      <FilterChip
        label={capitalize(values.providerLanguage)}
        emptyLabel="Any language"
        onDelete={() => setValues({ ...values, providerLanguage: "" })}
        onClick={onClick}
        selected={!!values.providerLanguage}
      />
    </Box>
    {allowUseOverflowShifts ? (
      <Box m={0.5}>
        <FilterChip
          label="Use overflow "
          emptyLabel="No overflow"
          onDelete={() => setValues({ ...values, useOverflowShifts: false })}
          onClick={onClick}
          selected={values.useOverflowShifts}
        />
      </Box>
    ) : null}
  </>
}
